import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GateWayService } from 'src/app/services/gateway.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, combineLatest, map, mergeMap, switchMap, withLatestFrom} from 'rxjs/operators';
import { GateWayActions, GateWayActionTypes } from '../actions/gateway.actions';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';
import {PreferenceService} from '../../../services/preference.service';

@Injectable()
export class GateWayEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private getwayService = inject(GateWayService);
  private preferenceService = inject(PreferenceService);

  constructor() {}

  ReadGatewayList$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayActionTypes.ReadGatewayList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = action.payload == null ? { otp: user.otp } : { ...action.payload, otp: user.otp };
      return this.getwayService.ReadGatewayList(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.UpsertGatewayList(res.msg.body)];
          } else {
            return [new featureActions.ReadGatewayListFail(res.errmsg.body)];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ReadGatewayListFail()];
        })
      );
    })
  ));
  AddGateway$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayActionTypes.AddGateway),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.AddMgtAttribute
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.AddGateway(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadGatewayList(), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Add Gateway Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Add Gateway Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
  UpdateGateway$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayActionTypes.UpdateGateway),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateGateway
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.UpdateGateway(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadGatewayList(), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Update Gateway Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Update Gateway Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
  DeleteGateway$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayActionTypes.DeleteGateway),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.DeleteGateway
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.DeleteGateway(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Delete Gateway Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Delete Gateway Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
  UpgradeGateway$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayActionTypes.UpgradeGateway),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpgradeGateway
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.UpgradeGateway(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.UpgradeGatewaySuccess(), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Upgrade Gateway Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Upgrade Gateway Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Upgrade Gateway Fail',
            type: updateInfoType.UpgradeGateway
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
}
